export const UI = {
  ro: {
    loading: "Se încarcă...",
    now: "Acum",
    today: "Astăzi",
    hourlyForecast: "Prognoză pe ore",
    weeklyForecast: "Prognoză pe 7 zile",
    unknown: "Necunoscut",
    error: "Nu s-a putut încărca vremea",
    highLow: (high, low) => `H:${high}° L:${low}°`,

    advice: {
      heavyRain: (time) =>
        `Ia o umbrelă — ploaie puternică așteptată în jur de ${time} 🌧️`,
      rain: (time) =>
        `Ia o jachetă — ploaie așteptată în jur de ${time} 🌦️`,
      hot: "Zi foarte caldă — bea mai multă apă și evită statul mult în soare 💧",
      perfect: "Vreme perfectă pentru o plimbare ☀️",
      mild: "Vreme plăcută — o jachetă ușoară este suficientă 🧥",
      cold: "Este frig azi — îmbracă-te bine ❄️",
      fog: "Ceață afară — condu atent și păstrează distanța 🌫️",
      storm: "Risc de furtună azi — mai bine planifici activități în interior ⛈️",
      calm: "Vreme liniștită azi — bucură-te de ea ✨",
      walkDrive:
        "Zi bună pentru o plimbare, o cafea afară sau o scurtă ieșire cu mașina 🚗",
      wet: "Pare o zi ploioasă — mai bine ține umbrela aproape ☔",
      chilly: "Zi răcoroasă înainte — hainele groase te vor ajuta 🧣",
      balanced: "Per total, o zi destul de echilibrată 👌",
    },

    weather: {
      0: "Senin",
      1: "Mai mult senin",
      2: "Parțial noros",
      3: "Acoperit",
      45: "Ceață",
      48: "Ceață cu chiciură",
      51: "Burniță ușoară",
      53: "Burniță",
      55: "Burniță densă",
      56: "Burniță înghețată ușoară",
      57: "Burniță înghețată puternică",
      61: "Ploaie ușoară",
      63: "Ploaie",
      65: "Ploaie puternică",
      66: "Ploaie înghețată",
      67: "Ploaie înghețată puternică",
      71: "Ninsoare ușoară",
      73: "Ninsoare",
      75: "Ninsoare puternică",
      77: "Granule de zăpadă",
      80: "Averse de ploaie",
      81: "Averse de ploaie",
      82: "Averse puternice",
      85: "Averse de ninsoare",
      86: "Averse puternice de ninsoare",
      95: "Furtună",
      96: "Furtună cu grindină",
      99: "Furtună severă",
    },
  },

  ru: {
    loading: "Загрузка...",
    now: "Сейчас",
    today: "Сегодня",
    hourlyForecast: "Почасовой прогноз",
    weeklyForecast: "Прогноз на 7 дней",
    unknown: "Неизвестно",
    error: "Не удалось загрузить погоду",
    highLow: (high, low) => `H:${high}° L:${low}°`,

    advice: {
      heavyRain: (time) =>
        `Возьми зонт — сильный дождь ожидается примерно в ${time} 🌧️`,
      rain: (time) =>
        `Возьми куртку — дождь ожидается примерно в ${time} 🌦️`,
      hot: "Очень тёплый день — пей больше воды и не будь долго под солнцем 💧",
      perfect: "Идеальная погода для прогулки ☀️",
      mild: "Хорошая погода — лёгкой куртки будет достаточно 🧥",
      cold: "Сегодня холодно — одевайся теплее ❄️",
      fog: "Туман — води аккуратнее и держи дистанцию 🌫️",
      storm: "Сегодня возможна гроза — лучше планировать дела в помещении ⛈️",
      calm: "Погода сегодня спокойная — наслаждайся ✨",
      walkDrive:
        "Хороший день для прогулки, кофе на улице или короткой поездки 🚗",
      wet: "Похоже, день будет мокрым — лучше держать зонт рядом ☔",
      chilly: "Впереди прохладный день — тёплая одежда не помешает 🧣",
      balanced: "В целом день довольно сбалансированный 👌",
    },

    weather: {
      0: "Ясно",
      1: "Преимущественно ясно",
      2: "Переменная облачность",
      3: "Пасмурно",
      45: "Туман",
      48: "Изморозный туман",
      51: "Лёгкая морось",
      53: "Морось",
      55: "Сильная морось",
      56: "Лёгкая ледяная морось",
      57: "Сильная ледяная морось",
      61: "Небольшой дождь",
      63: "Дождь",
      65: "Сильный дождь",
      66: "Ледяной дождь",
      67: "Сильный ледяной дождь",
      71: "Лёгкий снег",
      73: "Снег",
      75: "Сильный снег",
      77: "Снежные зёрна",
      80: "Ливни",
      81: "Ливни",
      82: "Сильные ливни",
      85: "Снежные заряды",
      86: "Сильные снежные заряды",
      95: "Гроза",
      96: "Гроза с градом",
      99: "Сильная гроза",
    },
  },
};